var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 52,
    viewBox: "0 0 41 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 52C24.8343 52 37.681 42.6667 41 38L34.5 0.5C34.5 20.9 11.7143 47.5 0 52Z",
    fill: "#E9F3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvyArrow);
export default __webpack_public_path__ + "static/media/curvyArrow.76c2d329c4515e756c8b5eecbfc31ced.svg";
export { ForwardRef as ReactComponent };